const BASE_ROUTE = "/onboarding/longevity";

export const LONGEVITY_ROUTE = {
  BASE: BASE_ROUTE,
  ACCOUNT_PERSONAL_DETAILS: `${BASE_ROUTE}/account-personal-details`,
  ACCOUNT_CONTACT_DETAILS: `${BASE_ROUTE}/account-contact-details`,
  CHECKOUT: `${BASE_ROUTE}/checkout`,
} as const;
